import { Box } from "@mui/material";
import { usePageTitle } from "app/hooks/usePageTitle";
import { PortalPage } from "modules/gate/pages/PortalPage";

const WorkspaceLandingPageComponent = () => {
    const landingPageStyle = { height: "calc(100vh - 64px)" };

    usePageTitle();

    return (
        <Box style={{ ...landingPageStyle, overflow: "hidden" }}>
            <PortalPage landing />
        </Box>
    );
};

export default WorkspaceLandingPageComponent;
